import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
    selector: 'custom-text-input',
    templateUrl: './custom-text-input.component.html',
    styleUrls: ['./custom-text-input.component.scss'],
    standalone: false
})
export class CustomTextInputComponent implements ControlValueAccessor {
  private onChange!: (value: string) => void;
  private onTouched!: () => void;

  _value = "";

  focused = false;
  
  public set value(v : string) {
    this._value = v;
    this.onChange(this._value);
  }
  
  public get value() : string {
    return this._value;
  }
  
  @Input() errorMessages: Record<string, string> = {}; 
  @Input() placeholder = "Please enter a value.";
    
  constructor(public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  writeValue(obj: string): void {
    this._value = obj;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  removeValue(){
    this.value = "";
  }

  setTouched(){
    this.focused = false;
    this.onTouched();
  }

  setFocused(){
    this.focused = true;
  }
}
